// Runtime configuration. Production mounts /config.json into the nginx root
// (the role templates it), so ONE web image serves any host. In dev the Vite
// env vars are the fallback, and mock mode needs nothing at all.
export type AppConfig = {
  apiBase: string;
  oidcAuthority?: string;
  oidcClientId?: string;
  mock: boolean;
};

let cfg: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (cfg) return cfg;
  const env = import.meta.env;
  const fromEnv: AppConfig = {
    apiBase: env.VITE_MDJ_API_BASE ?? "/api",
    oidcAuthority: env.VITE_OIDC_AUTHORITY,
    oidcClientId: env.VITE_OIDC_CLIENT_ID,
    mock: env.VITE_MDJ_MOCK === "1",
  };
  try {
    const res = await fetch("/config.json", { cache: "no-store" });
    if (res.ok) {
      const j = (await res.json()) as Partial<AppConfig>;
      cfg = { ...fromEnv, ...j, mock: Boolean(j.mock ?? fromEnv.mock) };
      return cfg;
    }
  } catch { /* no runtime config: env only */ }
  cfg = fromEnv;
  return cfg;
}

export function config(): AppConfig {
  if (!cfg) throw new Error("config not loaded");
  return cfg;
}
